Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _victoryUtil=require("../victory-util");

var _d3Shape=require("d3-shape");var d3Shape=_interopRequireWildcard(_d3Shape);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Curve=function(_React$Component){_inherits(Curve,_React$Component);function Curve(){_classCallCheck(this,Curve);return _possibleConstructorReturn(this,(Curve.__proto__||Object.getPrototypeOf(Curve)).apply(this,arguments));}_createClass(Curve,[{key:"componentWillMount",value:function componentWillMount()


















{var _calculateAttributes=
this.calculateAttributes(this.props),style=_calculateAttributes.style,paths=_calculateAttributes.paths;
this.style=style;
this.paths=paths;
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){var _calculateAttributes2=
this.calculateAttributes(nextProps),style=_calculateAttributes2.style,paths=_calculateAttributes2.paths;
if(!(0,_isEqual3.default)(paths,this.paths)||!(0,_isEqual3.default)(style,this.style)){
this.style=style;
this.paths=paths;
return true;
}
return false;
}},{key:"calculateAttributes",value:function calculateAttributes(

props){var
style=props.style,data=props.data,active=props.active,scale=props.scale,interpolation=props.interpolation;
var dataSegments=this.getDataSegments(data);
var xScale=scale.x;
var yScale=scale.y;
var lineFunction=d3Shape.line().
curve(d3Shape[this.toNewName(interpolation)]).
x(function(d){return xScale(d._x1!==undefined?d._x1:d._x);}).
y(function(d){return yScale(d._y1!==undefined?d._y1:d._y);});
return{
style:_victoryUtil.Helpers.evaluateStyle(
(0,_assign3.default)({fill:"none",stroke:"black"},style),data,active),

paths:dataSegments.map(function(d){return lineFunction(d);})};

}},{key:"getDataSegments",value:function getDataSegments(

data){
return _victoryUtil.Collection.splitArray(data,function(datum){
var yDatum=datum.y1!==undefined?datum._y1:datum._y;

return yDatum===null||typeof yDatum==="undefined";
}).filter(function(segment){return segment.length>1;});
}},{key:"toNewName",value:function toNewName(

interpolation){

var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
return"curve"+capitalize(interpolation);
}},{key:"renderLine",value:function renderLine(


paths,style,events){var _props=
this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
return paths.map(function(path,index){
return(
_react2.default.createElement("path",_extends({
key:"area-stroke-"+index,
style:style,
shapeRendering:shapeRendering||"auto",
role:role||"presentation",
d:path,
className:className},
events)));


});
}},{key:"render",value:function render()

{var _props2=
this.props,events=_props2.events,groupComponent=_props2.groupComponent;
var children=this.renderLine(this.paths,this.style,events);
return children.length===1?children[0]:_react2.default.cloneElement(groupComponent,{},children);
}}]);return Curve;}(_react2.default.Component);Curve.propTypes={active:_react.PropTypes.bool,index:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string]),className:_react.PropTypes.string,data:_react.PropTypes.array,events:_react.PropTypes.object,interpolation:_react.PropTypes.string,role:_react.PropTypes.string,scale:_react.PropTypes.object,shapeRendering:_react.PropTypes.string,style:_react.PropTypes.object,groupComponent:_react.PropTypes.element};Curve.defaultProps={groupComponent:_react2.default.createElement("g",null)};exports.default=Curve;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/curve.js
// module id = 1472
// module chunks = 0